export class AnalyticsConstants {
  public static readonly ANALYTICS_ENABLE_BEACON = false;
}
